<template>
  <div>
    <BaseCleanPopup
      v-zindex
      v-body
      :h="37"
      :winh="210"
      :winw="410"
      @close="$emit('close')"
    >
      <template v-slot:header>
        <span class="flex flex-align-center h-100">
          <span>{{ $t("editPdf.title") }}</span>
        </span>
      </template>
      <div class="flex-column h-100">
        <div class="content flex-g-1 flex-column flex">
          <div class="title padd-b-12 padd-r-12 rtl">
            {{ $t("editPdf.enterOrUpdate") }}
          </div>
          <div class=" flex-column flex-center input-rtl">
            <div class="mrg-b-12 ">
              <input
                v-select
                class="input-border"
                type="text"
                v-model="name"
                :placeholder="$t('advancSearchBook.nameBook')"
              />
            </div>
            <div class="mrg-b-12">
              <input
                class="input-border"
                type="text"
                v-model="auth"
                :placeholder="$t('advancSearchBook.author')"
              />
            </div>
          </div>
        </div>
        <footer class="footer flex-center w-100">
          <BaseButton class="" @click="updatePdfInfo">
            {{ $t("general.save") }}
          </BaseButton>
          <BaseButton class="w-fit-content" @click="$emit('close')">
            {{ $t("general.close") }}
          </BaseButton>
        </footer>
      </div>
    </BaseCleanPopup>
  </div>
</template>

<script>
import { doHardReload } from "../services/bookData";
import { Axios } from "../services/_axios";
export default {
  props: ["nameBook", "nameAuthor", "id"],
  data() {
    return {
      name: "",
      auth: "",
    };
  },
  created() {
    this.name = this.nameBook;
    this.auth = this.nameAuthor;
  },
  methods: {
    async updatePdfInfo() {
      try {
        await Axios.post("/api/pdf/update", {
          bookname: this.name,
          bookauth: this.auth,
          bookid: this.id,
        });
        //TODO add language
        const msg = this.$t("editPdf.succedUpdate");
        let payload = {
          title: this.$t("general.remove2"),
          content: msg,
          btns: [this.$t("general.confirm")],
        };
        await this.$msg(payload);
        doHardReload();
        this.$emit("close");
      } catch (ex) {
        console.error(ex);
        //TODO add language
        const msg = this.$t("editPdf.errorUpdate");
        let payload = {
          title: this.$t("general.remove2"),
          content: msg,
          btns: [this.$t("general.confirm")],
        };
        await this.$msg(payload);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  padding: 12px;
  padding-top: 20px;
}
.footer {
  display: flex;
  align-items: center;
  padding: 0 !important;
  margin: auto;
  height: 41px;
  background-color: #f7f7f7;
}
.input-border {
  width: 273px;
  margin: 0 auto;
  display: block;
}
</style>
